import { Link } from "react-router-dom";
import { Phone, MessageCircle, ClipboardList } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL } from "@/data/content";

const QuickActions = () => (
  <div
    data-testid="mobile-quick-actions"
    className="fixed bottom-0 inset-x-0 z-40 md:hidden grid grid-cols-3 bg-carbone/95 backdrop-blur-md border-t border-ivory/10"
  >
    <a
      href={PHONE_TEL}
      data-testid="quick-action-call"
      className="flex flex-col items-center gap-1 py-3 text-ivory/90 active:text-terracotta"
    >
      <Phone size={18} strokeWidth={1.5} />
      <span className="text-[10px] font-display tracking-[0.2em] uppercase">Chiama</span>
    </a>
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="quick-action-whatsapp"
      className="flex flex-col items-center gap-1 py-3 text-ivory/90 active:text-terracotta border-x border-ivory/10"
    >
      <MessageCircle size={18} strokeWidth={1.5} />
      <span className="text-[10px] font-display tracking-[0.2em] uppercase">WhatsApp</span>
    </a>
    <Link
      to="/contatti"
      data-testid="quick-action-sopralluogo"
      className="flex flex-col items-center gap-1 py-3 bg-terracotta text-ivory"
    >
      <ClipboardList size={18} strokeWidth={1.5} />
      <span className="text-[10px] font-display tracking-[0.2em] uppercase">Sopralluogo</span>
    </Link>
  </div>
);

export default QuickActions;
